export const THEMES = {
    KEY: 'theme',
    LIGHT: 'LIGHT',
    DARK: 'DARK',
    AUTO: 'AUTO'
}

export const ACCENT_COLORS = {
    KEY: 'accent_color',
    BLUE: 'BLUE',
    PURPLE: 'PURPLE',
    PINK: 'PINK',
    RED: 'RED',
    ORANGE: 'ORANGE',
    YELLOW: 'YELLOW',
    GREEN: 'GREEN',
}
